import { render, staticRenderFns } from "./PreviewForm5.vue?vue&type=template&id=444c85e2&scoped=true"
import script from "./PreviewForm5.vue?vue&type=script&lang=ts"
export * from "./PreviewForm5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c85e2",
  null
  
)

export default component.exports